// Navbar for main_app
export const mainNavbar = () => ({
  openMobileMenu: false,

  mobileMenuToggle: {
    [':aria-expanded']() {
      return this.openMobileMenu
    },
    ['@click']() {
      this.openMobileMenu = !this.openMobileMenu
    },
    ['x-text']() {
      return this.openMobileMenu ? 'close' : 'menu'
    },
  },
})

// Dropdown elements/components in the navbar
export const navDropdown = () => ({
  showDropdown: false,

  get dropdownIcon() {
    return this.showDropdown ? 'expand_less' : 'expand_more'
  },

  // Open the dropdown by hovering on desktop and by clicking on mobile
  // NOTE: Mobile behavior persists when going from a mobile view with an opened menu back to desktop view without closing the mobile menu first. It could be fixed e.g. by manually closing the mobile menu when screen size changes, but it probably isn't an issue in normal use.
  dropdownWrapper: {
    ['@mouseenter']() {
      if (!this.openMobileMenu) this.showDropdown = true
    },
    ['@mouseleave']() {
      if (!this.openMobileMenu) this.showDropdown = false
    },
    ['@click']() {
      if (this.openMobileMenu) this.showDropdown = !this.showDropdown
    },
  },
  dropdownContent: {
    ['@click.outside']() {
      if (this.openMobileMenu) this.showDropdown = false
    },
    ['x-show']() {
      return this.showDropdown
    },
  },
})
